import { Stack, Text, textDecoration } from '@chakra-ui/react'
import { isBefore, parseISO } from 'date-fns/esm'
import React, { FC } from 'react'
import { useLang } from '../../common/i18n/useLang'
import { Announce } from './Announce'

const FIN_PSD_APPLICATION_CLOSED = parseISO('2025-05-30T23:59:59+09:00')

export function showPsdApplicationClosed() {
  // Start date is immediate (or from May 30), so only check the end date for display period
  return isBefore(new Date(), FIN_PSD_APPLICATION_CLOSED)
}

export const Maintenance: FC<{ radius?: number; className?: string }> = ({ radius, className }) => {
  const { language } = useLang()
  const shouldShowPsdClosed = showPsdApplicationClosed()

  // if (!shouldShowPsdClosed) {
  //   return null
  // }
  return null

  return (
    <Stack spacing={4} className={className}>
      {shouldShowPsdClosed && (
        <Announce
          radius={radius}
          type={'warning'}
          title={language === 'ja' ? '大切なお知らせ' : 'Important Notice'}
          body={
            language === 'ja' ? (
              <div>
                2026年度システム情報科学府入学試験のためのPSD申請は2025年5月30日をもって終了しました。
              </div>
            ) : (
              <div>
                Calls for the pre-admission request for the 2026 ISEE entrance exams were closed on May 30, 2025.
              </div>
            )
          }
        />
      )}
    </Stack>
  )
}
